package com.cybersoftsolution.cybersoftsolutionweb.use_cases

import com.cybersoftsolution.cybersoftsolutionweb.api.getPostById
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastStyle
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.showMyToast
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.CreatePostUI
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.ToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.toastBasicID
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay


suspend fun CoroutineScope.getPostByIdUseCase(
    id: String,
    state: CreatePostUI,
    setLoading: (Boolean) -> Unit,
    setState: (CreatePostUI) -> Unit,
){
    val scope = this

    setLoading(true)

    getPostById(
        id = id
    ).also { response ->


        delay(50)
        console.log(response)


        if (response?.data != null && !response.message.isNullOrEmpty())  {
            setState(
                state.copy(
                    post = response.data,
                    toastMessage = ToastMessage(
                        message = response.message,
                        style = MyToastStyle.Success
                    )
                )
            ).also {
                scope.showMyToast(toastBasicID)
            }

        } else {
            setState(
                state.copy(
                    toastMessage = ToastMessage(
                        message = response?.message?:"Error al obtener los datos",
                        style = MyToastStyle.Danger
                    )
                )
            ).also {
                scope.showMyToast(toastBasicID)
            }
        }




        setLoading(false)


    }
}